(function (cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:

  (lib.Symbol1 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#232830')
      .s()
      .p(
        'AgGAoIgBAAQgXgVgHgJQgMgOABgNQAAgMALgJQAJgGALACQALACAGAIQAHgIAKgCQALgCAJAGQALAIABANQABANgMAOQgIAJgXAVIAAAAQgEADgDAAQgDAAgDgDg',
      );
    this.shape.setTransform(0, -4.3485);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-4.9, -8.7, 9.8, 8.7);

  // stage content:
  (lib.Handandheart = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = false;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#232830')
      .s()
      .p(
        'AhdAxQgGgFAAgJIAAhFQAAgIAGgGQAGgGAIAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgIAAgGgGgAAkAsIhLgIIAAhaIASACIAOADQAGACAZAQQAYAPAFABQACAAABAFQABAEgBADQgBAEgDACIgHACQgKACgQgGIgLgBIgGgDIgBADIARAEIAbADQAEgBABgBIAcgTQAGgDAEACIAHAGQAIAIgFAGQgDAFgvAiIgHABIgFgBg',
      );
    this.shape.setTransform(10.9344, 16.5);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#232830')
      .s()
      .p(
        'AhdAxQgGgFAAgJIAAhFQAAgIAGgGQAGgGAIAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgIAAgGgGgAAkAsIhLgIIAAhaIASACIAOADQAGACAZAQQAYAPAFABQACAAABAFQABAEgBADQgBAEgDACIgHACQgKACgQgGIgLgBIgGgDIgBADIARAEIAbADQAEgBALgHIARgMQAHgEAEACIAHAGQAIAIgFAGQgDAFgvAiIgHABIgFgBg',
      );
    this.shape_1.setTransform(10.9344, 16.5);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#232830')
      .s()
      .p(
        'AheAxQgFgFAAgJIAAhFQAAgIAFgGQAGgGAJAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgJAAgGgGgAAkAtIgFAAIgMgBIg6gIIAAgFIAAhVIAPACQAYAGAXAOQAQAJAJAEIAFADQACABABAEQABAEgBADIgCAEIgCABIgFABIgDABQgKACgNgEIgEgBIgJgBIgDgBIgEgCIAAADIAHACIAJADIAFABIAEAAIASACQAFgBAKgGQALgHAHgDQAEgDAEAAIAEABIAHAFIACADQAEAGgDAGIAAABQgKAHgpAcIgIABIgEAAg',
      );
    this.shape_2.setTransform(10.9893, 16.5);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#232830')
      .s()
      .p(
        'AhfAxQgFgFAAgJIAAhFQAAgIAFgGQAGgGAJAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgJAAgGgGgAAkAuIgGAAIgLAAIg6gKIgBgEIAAhWIAPABQAZAIAWAMQAQAJAKAEIAFADQACABAAAEQABAEgBADIgCAEIgCACIgFAAIgDABQgKACgNgDIgEgBIgJgDIgCgBIgEAAQAAAAgBAAQAAAAAAABQAAAAAAAAQAAABAAAAQACACAEABIAJADIAGABIAEAAIARACQAGgBAKgFQALgGAIgCQAEgCAEAAIAEABIAGAEIADADQAFAFgDAGIgBABIgzAiQgEABgGAAIgCAAg',
      );
    this.shape_3.setTransform(11.0696, 16.5);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#232830')
      .s()
      .p(
        'AhfAxQgGgFAAgJIAAhFQAAgIAGgGQAGgGAIAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgIAAgGgGgAATAvIg6gLIgCgEIAAhWIAPABQAaAIAWALQAPAJALADIAFAEQACABAAAEQABAFgBACIgCADIgCADIgFAAIgDABQgLABgNgCIgDgBIgKgDIgCgBIgEAAIAAACQABADAEABIAOAEIAWABQAGAAAKgFQALgDAJgDIAIgCIAEABIAHAFIADACQAEAFgCAHIAAABIg1AfQgGACgGAAIgFAAIgEABIgIgBg',
      );
    this.shape_4.setTransform(11.1308, 16.5);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#232830')
      .s()
      .p(
        'AhgAxQgGgFAAgJIAAhFQAAgIAGgGQAGgGAIAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgIAAgGgGgAATAwIg6gMIgDgCIAAhYIAQABQAbAIAUALIAaALQAEACACACQACABAAAEIgBAHIgCADIgCADIgFABIgDAAQgLAAgMgBIgEAAIgMgFIgDAAIgBACQABAEADABIAJACIAJACIASABQAHAAAKgEQALgDAKgBIAIgBIAEAAIAGAEIADACQAFAGgBAHIAAABQgTAJgjAUQgGACgGAAIgFAAIgGABIgGgBg',
      );
    this.shape_5.setTransform(11.2083, 16.5);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#232830')
      .s()
      .p(
        'AhhAxQgFgFAAgJIAAhFQAAgIAFgGQAGgGAJAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgJAAgGgGgAATAyIg6gOIgDgCIAAhYIAPABQAdAIATAKIAaALQAEACACACQACACAAAEIgBAHIgCACIgCACQgCACgDAAIgEAAQgLAAgMgBIgEgBIgLgEIgDAAIgBACQgBAEAEABIAOAEIAEABIASAAQAIAAAKgCIAVgDIAIAAIAEAAIAHADIADADQAFAFgBAIIAAAAQgWALghAQIgMADIgFABIgGABIgGgBg',
      );
    this.shape_6.setTransform(11.2773, 16.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#232830')
      .s()
      .p(
        'AhiAxQgFgFAAgJIAAhFQAAgIAFgGQAGgGAJAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgJAAgGgGgAATA0Ig+gRIAAhZIAPAAQAeAKASAIIAbALQAEACACACQACACAAAEQAAAEgCADIgCACIgCACIgFABIgEAAIgXAAIgDgBIgKgDIgCgBQAAAAgBAAQAAAAgBAAQAAAAAAAAQAAAAgBABIgBABQgBAFADABIAPAEIADABIASAAIASgBIAXgCIAIAAIAEAAIAGADIAEAEQAFAFAAAHIAAABIg4AYIgMAEIgFACIgHAAIgFAAg',
      );
    this.shape_7.setTransform(11.375, 16.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#232830')
      .s()
      .p(
        'AhiAxQgGgFAAgJIAAhFQAAgIAGgGQAFgGAJAAQAIAAAGAGQAGAGAAAIIAABFQAAAJgGAFQgGAGgIAAQgJAAgFgGgAATA2Ig/gSIAAhaIAPAAIAIACIBEAaQAIACAAAIQgBAFgDAEQgDADgFAAIgaAAIgEgBIgLgEQgEgBgCAEQgBAEAFACIANAEIAEABIBDAAQAJAAAGAGQAGAFAAAJIhKAcIgHABIgFAAg',
      );
    this.shape_8.setTransform(11.45, 16.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 14)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_8 }] }, 7)
        .wait(1),
    );

    // Layer_1
    this.instance = new lib.Symbol1('synched', 0);
    this.instance.setTransform(15.1, 11.65, 0.3103, 0.3103, 0, 0, 0, 0, -4.4);
    this.instance.alpha = 0.0781;
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(14)
        .to({ _off: false }, 0)
        .to(
          {
            regX: 0.1,
            regY: -4.2,
            scaleX: 1.1224,
            scaleY: 1.1065,
            x: 15.2,
            y: 6.4,
            alpha: 1,
          },
          12,
        )
        .to(
          { regX: 0, regY: -4.4, scaleX: 1, scaleY: 1, x: 15.1, y: 6.6 },
          2,
          cjs.Ease.quadInOut,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(13, 13.4, 9, 8.6);
  // library properties:
  lib.properties = {
    id: 'F1976A90FA68486398CD454FD92272A3',
    width: 24,
    height: 24,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['F1976A90FA68486398CD454FD92272A3'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));
var createjs, AdobeAn;
